// Action types
import { createRequestTypes } from "../../utils";

export const FETCH_MEMBERSHIPS = createRequestTypes("FETCH_MEMBERSHIPS");
export const CHECKOUT_MEMBERSHIP = createRequestTypes("CHECKOUT_MEMBERSHIP");

// FETCH
export const fetchMembershipsRequest = () => (
    { type: FETCH_MEMBERSHIPS.REQUEST });

export const fetchMembershipsSuccess = (memberships) =>
    ({ type: FETCH_MEMBERSHIPS.SUCCESS, payload: memberships });

export const fetchMembershipsFailure = (error) =>
    ({ type: FETCH_MEMBERSHIPS.FAILURE, payload: error });

// CHECKOUT
export const checkoutMembershipRequest = (data) =>
    ({ type: CHECKOUT_MEMBERSHIP.REQUEST, payload: data });

export const checkoutMembershipSuccess = (urlStripe) =>
    ({ type: CHECKOUT_MEMBERSHIP.SUCCESS, payload: { urlStripe } });

export const checkoutMembershipFailure = (errorMessage) =>
    ({ type: CHECKOUT_MEMBERSHIP.FAILURE, payload: { errorMessage } });